export function testBrowserType(reg, type) {
  var external = window.external || {};
  for (var i in external) {
    if (reg.test(type ? external[i] : i)) {
      return true;
    }
  }
  return false;
}